import is from 'is_js';
import Immutable, { Record, List, Set } from 'immutable';
import { status as HomeworkStatus } from 'data/Homework';

const PersonalisedHomeworkItemRecord = Record({
  type: undefined,
  homeworkTypeId: undefined,
  content: undefined,
});

const PersonalisedHomeworkRecord = Record({
  id: undefined,
  sessionId: undefined,
  homeworkId: undefined,
  contents: undefined,
  createdByUserId: undefined,
  studentIds: new Set(),  // necessary
  status: HomeworkStatus.NEW,
  homeworkType: undefined,
});

class PersonalisedHomeworkItem extends PersonalisedHomeworkItemRecord { }
class PersonalisedHomework extends PersonalisedHomeworkRecord { }
PersonalisedHomework.Item = PersonalisedHomeworkItem;

const reviver = ([key, item]) => {
  if (! item) return [key, item];
  switch (key) {
    case 'id':
    case 'sessionId':
    case 'homeworkId':
    case 'createdByUserId':
      return [key, `${item}`];
    case 'studentIds':
      return [key, new Set(item.map((i) => i.toString()))];
    case 'contents':
      return [key, new List(
          item.map((i) => new PersonalisedHomeworkItem(i)))];
    default:
      return [key, Immutable.fromJS(item)];
  }
};

const serializer = ([key, item]) => {
  switch (key) {
    case 'id':
    case 'sessionId':
    case 'homeworkId':
      return [key, Number.parseInt(item, 10)];
    // the server sets these; remove them when serializing
    case 'createdByUserId':
      return [key, undefined];
    default:
      return [key, item];
  }
};

PersonalisedHomework.create = (data = {}) => {
  if (! data.contents) {
    data.contents = [{}];  // eslint-disable-line
  }
  return new PersonalisedHomework(data).mapEntries(reviver);
};

PersonalisedHomework.serialize = (model) => {
  let serializedModel = model;
  if (serializedModel instanceof PersonalisedHomework) {
    // toMap() because https://github.com/facebook/immutable-js/issues/574
    serializedModel = serializedModel.toMap().mapEntries(serializer);
    serializedModel = serializedModel.filter((val) =>
      is.not.nan(val) && is.existy(val)
    ).toObject();
  }
  serializedModel.studentIds =
      serializedModel.studentIds.toArray().map((id) => Number.parseInt(id, 10));
  return serializedModel;
};

PersonalisedHomework.validate = (model) => !! (
  model instanceof PersonalisedHomework &&
  List.isList(model.contents) &&
  model.studentIds.size && model.contents.size &&
  model.contents.every(PersonalisedHomeworkItem.validate)
);

PersonalisedHomeworkItem.validate = (model) => !! (
  model instanceof PersonalisedHomeworkItem &&
  model.homeworkTypeId &&
  model.content && model.content.length
);

export default PersonalisedHomework;



// WEBPACK FOOTER //
// ./data/OnlineHomework/Personalised/model.js